import { DataLoadedStatus, PolicyAppState } from '../../types';
import { ModuleId, SectionId } from '@nirvana/shared/dtos/types/policies/common';
import { createAction, PayloadAction } from '@reduxjs/toolkit';
import { PoliciesReduxActions } from '../../actions';

// SELECTORS
export const getIsContentControlWebAdditionalInfoLoaded = (state: PolicyAppState): DataLoadedStatus =>
  state.modules[ModuleId.CONTENT_CONTROL]?.sections[SectionId.CONTENT_CONTROL_WEB]?.additionalInfo.schedulersLoaded ??
  DataLoadedStatus.NOT_LOADED;

// ACTIONS
export const setAvailableSchedulersLoadedForContentControlWeb = createAction<DataLoadedStatus>(
  PoliciesReduxActions.SET_AVAILABLE_SCHEDULERS_LOADED_FOR_CONTENT_CONTROL_WEB
);
export const setAvailableSchedulersLoadedForContentControlWebActionHandler = (
  state: PolicyAppState,
  action: PayloadAction<DataLoadedStatus>
): void => {
  const module = state.modules[ModuleId.CONTENT_CONTROL];

  if (!module) {
    return;
  }

  module.sections[SectionId.CONTENT_CONTROL_WEB].additionalInfo.schedulersLoaded = action.payload;
};
